module.exports = __webpack_public_path__ + "img/noobizes-manette.a1c7e317.png";